// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
// Slices
import {
  checkMembershipSaveDisabled,
  fetchMemberships,
} from 'slices/memberships.slice';
import { requestObjectTypes } from 'slices/objectTypes.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import MembershipDrawer from './MembershipDrawer';
import MembershipList from './MembershipList';

const MembershipsPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchMemberships());
    dispatch(requestObjectTypes());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isSaveDisabled = dispatch(
        checkMembershipSaveDisabled(isFirstDrawer)
      );
      if (!isSaveDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('memberships')}
      subtitle={getText('memberships_subtitle')}
    >
      <div className="inner-content--wrapper">
        <MembershipList confirmDiscardChanges={confirmDiscardChanges} />
        <MembershipDrawer confirmDiscardChanges={confirmDiscardChanges} />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default MembershipsPage;
